// TODO: i18n — see Auth.js for pattern, replace hardcoded strings with t('namespace.key')
import { useState } from 'react'
import { supabase } from '../supabase'

const C = {
  bg: '#F2EDE4', card: '#FDFAF6', border: '#DDD4C6',
  amber: '#B8721F', amberLight: '#D4902A', brown: '#2C1D14',
  muted: '#9A7B68', danger: '#B03020', success: '#2E6B4A',
  dangerBg: '#FDECEA',
}
const f = 'Georgia, serif'
const fs = 'Calibri, sans-serif'

const CATEGORY_LABELS = {
  hvac: 'HVAC', landscaping: 'Landscaping', gutters: 'Gutter Cleaning',
  pest_control: 'Pest Control', pool: 'Pool Service', housekeeping: 'Housekeeping',
  windows: 'Window Cleaning', security: 'Security System', other: 'Other',
  'HVAC': 'HVAC', 'Landscaping': 'Landscaping', 'Plumbing': 'Plumbing',
  'Roofing': 'Roofing', 'Electrical': 'Electrical', 'General': 'General',
}

export default function ContractorRequestModal({ contractor, session, activeHomeId, onClose, onSubmitted }) {
  const rawCats = contractor?.category || []
  const categories = Array.isArray(rawCats) ? rawCats : [rawCats].filter(Boolean)
  const [category, setCategory] = useState(categories[0] || 'other')
  const [description, setDescription] = useState('')
  const [preferredDate, setPreferredDate] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState(null)
  const [focus, setFocus] = useState('')

  const inp = (foc) => ({
    width: '100%', background: C.bg, border: `1px solid ${focus === foc ? C.amber : C.border}`,
    borderRadius: '8px', padding: '11px 14px', fontSize: '15px', fontFamily: f, color: C.brown,
    boxSizing: 'border-box', outline: 'none', marginBottom: '14px', transition: 'border-color 0.2s',
  })
  const lbl = { fontSize: '10px', color: C.muted, letterSpacing: '1.5px', textTransform: 'uppercase', marginBottom: '5px', display: 'block', fontFamily: fs }

  const handleSubmit = async () => {
    if (!description.trim()) { setError('Please describe what you need help with.'); return }
    setSubmitting(true)
    setError(null)
    const { error: dbError } = await supabase.from('contractor_requests').insert({
      home_id: activeHomeId,
      user_id: session?.user?.id,
      contractor_id: contractor?.id,
      category,
      description: description.trim(),
      preferred_date: preferredDate || null,
      status: 'pending',
    })
    setSubmitting(false)
    if (dbError) { setError(dbError.message); return }
    setSubmitted(true)
    setTimeout(() => { onSubmitted?.(); onClose() }, 2500)
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(44,29,20,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px', fontFamily: f }}
      onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={{ background: C.card, borderRadius: '16px', width: '100%', maxWidth: '460px', boxShadow: '0 8px 40px rgba(44,29,20,0.2)', border: `1px solid ${C.border}` }}>
        <div style={{ padding: '24px 28px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
          <div>
            <div style={{ fontSize: '20px', fontWeight: '700', color: C.brown }}>Request Service</div>
            <div style={{ fontSize: '13px', color: C.muted, fontFamily: fs, marginTop: '2px' }}>
              {contractor?.business_name || contractor?.name}
            </div>
          </div>
          <button style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer', color: C.muted, padding: 0, lineHeight: 1 }} onClick={onClose}>×</button>
        </div>
        <div style={{ padding: '20px 28px 28px' }}>
          {submitted ? (
            <div style={{ textAlign: 'center', padding: '16px 0' }}>
              <div style={{ fontSize: '40px', marginBottom: '12px' }}>✓</div>
              <div style={{ fontSize: '18px', fontWeight: '700', color: C.success, marginBottom: '8px' }}>Request Sent!</div>
              <div style={{ fontSize: '14px', color: C.muted, fontFamily: fs }}>We'll be in touch shortly.</div>
            </div>
          ) : (
            <>
              {error && <div style={{ borderRadius: '8px', padding: '10px 14px', marginBottom: '14px', fontSize: '13px', fontFamily: fs, background: C.dangerBg, border: `1px solid ${C.danger}44`, color: C.danger }}>{error}</div>}

              {categories.length > 1 && (
                <>
                  <label style={lbl}>Service Type</label>
                  <select style={{ ...inp('cat'), cursor: 'pointer', appearance: 'none' }} value={category} onChange={e => setCategory(e.target.value)} onFocus={() => setFocus('cat')} onBlur={() => setFocus('')}>
                    {categories.map(c => <option key={c} value={c}>{CATEGORY_LABELS[c] || c}</option>)}
                  </select>
                </>
              )}

              <label style={lbl}>What do you need help with?</label>
              <textarea
                style={{ ...inp('desc'), resize: 'vertical', minHeight: '90px' }}
                placeholder="Describe the work needed..."
                value={description} onChange={e => { setDescription(e.target.value); setError(null) }}
                onFocus={() => setFocus('desc')} onBlur={() => setFocus('')}
              />

              <label style={lbl}>Preferred Date <span style={{ textTransform: 'none', letterSpacing: 0 }}>(optional)</span></label>
              <input type="date" style={inp('date')} value={preferredDate} onChange={e => setPreferredDate(e.target.value)} onFocus={() => setFocus('date')} onBlur={() => setFocus('')} />

              <div style={{ display: 'flex', gap: '10px' }}>
                <button style={{ flex: 1, background: 'transparent', border: `1px solid ${C.border}`, borderRadius: '10px', padding: '12px', color: C.muted, fontSize: '13px', cursor: 'pointer', fontFamily: f }} onClick={onClose}>Cancel</button>
                <button
                  style={{ flex: 2, background: submitting ? C.border : `linear-gradient(135deg, ${C.amber}, ${C.amberLight})`, border: 'none', borderRadius: '10px', padding: '13px', color: submitting ? C.muted : C.card, fontSize: '14px', fontWeight: '700', cursor: submitting ? 'not-allowed' : 'pointer', fontFamily: f, letterSpacing: '1px', textTransform: 'uppercase' }}
                  onClick={handleSubmit} disabled={submitting}
                >
                  {submitting ? 'Sending...' : 'Send Request'}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
